module.exports = __webpack_public_path__ + "static/media/5.e2f0e969.jpg";